import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import auth from './modules/auth';
import player from './modules/player';
import queue from './modules/queue';
import room from './modules/room';
import commissioner from './modules/commissioner';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		user,
		auth,
		player,
		queue,
		room,
		commissioner,
	},
	state: {
		current_picker: { name: null, id: null },
		current_round: null,
	},
	getters: {
		hasDraftStarted: state =>
			!!(
				state.current_picker &&
				state.current_picker.name &&
				state.current_picker.id
			),
		room_id: state => state.room.id,
	},
	mutations: {
		set_current_picker(state, payload) {
			state.current_picker = payload;
		},
		set_current_round(state, payload) {
			state.current_round = payload;
		},
	},
});
